module.exports = __webpack_public_path__ + "media/images/today-86c86044896ebb64a6c91ccd07c777cc.svg";